import SystemBanners from "Pages/SystemBanners";

export const constants = {
  PROJECT_OWNER: "Project Owner",
  PROJECT_USER: "Project User",
  PROJECT_USER_SENIOR: "Project Senior User",
  PROJECT_MANAGER: "Project Manager",
  PROJECT_ADMIN: "Project Admin",
  PROJECT_GUARD: "Security Guard",
  PROJECT: "project",
  PROJECT_SETTING: "project setting",
  USER: "user",
  USER_DETAILS: "User Details",
  SITE_DATA: "Site Data",
  REGION: "Region",
  HOUR_24: "24 hour",
  HOUR_12: "12 hour",
  TIME_FORMAT: "TIME_FORMAT",
  GOOGLE_MAP_MARKER:
    "https://icon-library.com/images/pin-icon-png/pin-icon-png-23.jpg",
};

export const ls_vars = {
  ACCESS_TOKEN: "v3_access_token",
  REFRESH_TOKEN: "v3_refresh_token",
  LANGUAGE: "i18nextLng",
  FEATURE_FLAGS: "v3_feature_flags",
  REGIONS: "v3_regions",
  REGION_ID: "v3_region_id",
  PROJECT_REF: "v3_project_ref",
  PROJECT_DATA: "v3_project_data",
  PROJECT_TIMEZONE: "v3_project_timezone",
  PROJECT_SETTINGS: "v3_project_settings",
  PROJECT_BOOKING_FIELDS: "v3_project_booking_fields",
  PROJECT_PROCORE_INTEGRATION_ID: "v3_project_procore_int_id",
  PROJECT_SITE_ID: "v3_project_site_id",
  PROJECT_ROLE: "v3_project_role",
  USER_DATA: "v3_user_data",
  USER_PROJECTS: "v3_user_projects",
  USER_PREFERENCES: "v3_user_preference",
  USER_IS_ADMIN: "v3_user_is_admin",
  USER_INVITE_DATA: "v3_user_invite_data",
  BOOKING_FLEX_FORMS: "v3_booking_flex_forms",
  COUNTRY_CODE: "v3_country_code",
  PLATFORMS_LIST: "v3_platforms_list",
  PLATFORM: "v3_platform",
};

const ROUTE_DASHBOARD = "dashboard";

export const routes = {
  root: {
    token: "/",
    dashboard: ROUTE_DASHBOARD,
  },
  dashboard: {
    account: "account",
    projects: "projects",
    project: "projects/:ref",
    organizations: "organizations",
    organization: "organizations/:ref",
    roles: "roles",
    users: "users",
    user: "users/:ref",
    platforms: "platforms",
    webhooks: "webhooks",
    webhook: "webhooks/:ref",
    equipmentMaster: "equipment-master",
    vehicleMaster: "vehicle-master",
    systemBanners: "system-banners",
    anthropicKey: "global-variables/anthropic-key",
    anthropicModel: "global-variables/anthropic-model",
    inventoryLedgerAlerts: "global-variables/inventory-ledger-alerts"
  },
  dashboardNav: {
    account: () => `/${ROUTE_DASHBOARD}/account`,
    projects: () => `/${ROUTE_DASHBOARD}/projects`,
    project: (ref: string) => `/${ROUTE_DASHBOARD}/projects/${ref}`,
    organizations: () => `/${ROUTE_DASHBOARD}/organizations`,
    organization: (ref: string) => `/${ROUTE_DASHBOARD}/organizations/${ref}`,
    roles: () => `/${ROUTE_DASHBOARD}/roles`,
    users: () => `/${ROUTE_DASHBOARD}/users`,
    user: (ref: string) => `/${ROUTE_DASHBOARD}/users/${ref}`,
    platforms: () => `/${ROUTE_DASHBOARD}/platforms/`,
    webhooks: () => `/${ROUTE_DASHBOARD}/webhooks/`,
    webhook: (id: number) => `/${ROUTE_DASHBOARD}/webhooks/${id}`,
    equipmentMaster: () => `/${ROUTE_DASHBOARD}/equipment-master`,
    vehicleMaster: () => `/${ROUTE_DASHBOARD}/vehicle-master`,
    systemBanners: () => `/${ROUTE_DASHBOARD}/system-banners`,
    anthropicKey: () => `/${ROUTE_DASHBOARD}/global-variables/anthropic-key`,
    anthropicModel: () => `/${ROUTE_DASHBOARD}/global-variables/anthropic-model`,
    inventoryLedgerAlerts: () => `/${ROUTE_DASHBOARD}/global-variables/inventory-ledger-alerts`
  },
};
